import React from "react";
import { Modal, Button } from "react-bootstrap";

const RestartResumeModal = ({ show, onRestart, onResume, page }) => {
  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header>
        <Modal.Title>Continue Viewing?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          It looks like you refreshed the page{page ? ` on page ${page}` : ""}.
          Would you like to resume where you left off or start a new session?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onRestart}>
          Restart
        </Button>
        <Button variant="primary" onClick={onResume}>
          Resume
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RestartResumeModal;
